var dev_tools = {
    hot_reload_styles: function(){
        var links = document.getElementsByTagName('link');
        for (var i = 0; i < links.length; i++) {
            var link = links[i];
            if (link.rel === 'stylesheet') {
                link.href = link.href + '?id=' + new Date().getTime();
            }
        }
    },
    add_reload_button: function(overrideKeyReloadAction = false){
        var button = document.createElement('button');
        button.innerHTML = 'Reload Styles';
        button.style.position = 'fixed';
        button.style.top = '0';
        button.style.right = '0';
        button.style.zIndex = '999999';
        button.style.padding = '10px';
        button.style.backgroundColor = '#000';
        button.style.color = '#fff';
        button.style.border = 'none';
        button.style.cursor = 'pointer';
        button.addEventListener('click', function(){
            dev_tools.hot_reload_styles();
        });
        document.body.appendChild(button);

        if (overrideKeyReloadAction) {
            document.addEventListener('keydown', function(e){
                if (e.ctrlKey && e.key === 'r') {
                    e.preventDefault();
                    dev_tools.hot_reload_styles();
                }
            });
        }
    },
    init: function(){
        console.log('Dev tools initialized');
    },
};

window.dev_tools = dev_tools;

if (window.location.hostname === 'localhost' || window.location.hostname === 'portacool.local') {
    return; //If you re-enable this, don't commit it to the repo. Hard reload hotkey is disabled by this code, and is needed for some debugging work.
    window.dev_tools.init();
    window.dev_tools.add_reload_button(true);
}